import { useEffect } from "react";
import { Navigate, useOutletContext, useParams } from "react-router-dom";

export default function AssistantRedirect() {
  const { contextName } = useParams();
  const { openAssistant } = useOutletContext() || {};

  useEffect(() => {
    openAssistant?.(contextName || null);
  }, [contextName, openAssistant]);

  return <Navigate to="/" replace />;
}
